/**
 * Platform screens shared by every module (job history for bulk uploads, and
 * the bin that holds whatever has been deleted anywhere in the product).
 * The server decides what each person may see in them.
 */
import { lazy, type ReactElement } from 'react';
import { Route } from 'react-router-dom';

const ImportJobsPage = lazy(() => import('./imports/ImportJobsPage').then((m) => ({ default: m.ImportJobsPage })));
const ImportJobDetailPage = lazy(() => import('./imports/ImportJobsPage').then((m) => ({ default: m.ImportJobDetailPage })));
const TrashBinPage = lazy(() => import('./trash/TrashBinPage').then((m) => ({ default: m.TrashBinPage })));

export function platformRoutes(): ReactElement[] {
  return [
    <Route key="imports" path="imports" element={<ImportJobsPage />} />,
    <Route key="import" path="imports/:id" element={<ImportJobDetailPage />} />,
    <Route key="trash" path="trash" element={<TrashBinPage />} />,
  ];
}
